<template>
	<div class="login-page">
		<!-- <video :src="backgroundVideo" autoplay loop muted :poster="backgroundImage">您的浏览器不支持HTML5视频标签。</video> -->
		<img class="bg" src="@/assets/bg.png" alt="" />
		<!-- <router-link tag="div" class="logo" :to="{ name: 'home' }">
			<svg-icon name="logo" />
		</router-link> -->
		<div class="body">
			<div class="body-left">
				<div class="heading-1">中国集装箱行业</div>
				<div class="heading-2">绿色低碳公共服务平台</div>
				<!-- <div class="des">探索碳足迹管理提供了基础数据支撑，加快推动碳足迹管理体系建设探索碳足迹管理提供了基础数据支撑，加快推动碳足迹管理体系建设</div> -->
			</div>
			<div class="body-right">
				<el-form :model="forgetForm" :rules="forgetRule" ref="forgetForm" class="card forget-card" v-if="true">
					<!-- 忘记密码-步骤一 -->
					<div class="form step-1" v-show="forgetStep == 1">
						<div class="form-header">
							<div class="back" @click="back">
								<svg-icon name="arrowleft"></svg-icon>
							</div>
							<div class="heading">找回密码</div>
						</div>
						<el-form-item prop="mobile">
							<div class="phone-box">
								<el-input clearable v-model="forgetForm.mobile" placeholder="请输入注册时的手机号" v-maxlength="11" type="number"></el-input>
							</div>
						</el-form-item>
						<el-form-item prop="confirmSuccess">
							<div class="slide" @mousedown.capture="checkCanSliderCode">
								<SliderCode :key="sliderKey" ref="SliderCode" @confirmSuccessBool="confirmSuccessFn"></SliderCode>
							</div>
						</el-form-item>
						<div class="tip">手机号不可用？联系客服</div>
						<el-button class="send-btn" type="primary" @click="sendCode">发送验证码</el-button>
						<div class="card-footer">
							<div class="forget">
								已有账户!
								<router-link tag="div" class="tologin" :to="{ name: 'login' }">
									<span class="c-primary c-pointer">去登录</span>
									<img src="@/assets/img/002.png" alt="" />
								</router-link>
							</div>
						</div>
					</div>
					<!-- 忘记密码-步骤二 -->
					<div class="form step-2" v-show="forgetStep == 2">
						<div class="form-header">
							<div class="back" @click="back">
								<svg-icon name="arrowleft"></svg-icon>
							</div>
							<div class="heading">输入验证码</div>
						</div>
						<div class="tip">验证码已发送至{{ forgetForm.mobile }}，有效期60秒</div>
						<el-form-item prop="">
							<div class="code-box">
								<template v-for="(item, index) in inputList">
									<el-input :ref="`inputList-${index}`" v-model="item.pinless" type="number" v-maxlength="1"></el-input>
									<div class="line" v-if="index == 2"></div>
								</template>
							</div>
						</el-form-item>
						<div class="reSend" v-if="codeNum == 0" @click="sendCode">重新获取</div>
						<div v-else class="reSend">
							{{ codeNum }}秒
							<span :style="{ color: 'var(--color-text-4)' }">后可重新发送验证码</span>
						</div>
					</div>
					<!-- 忘记密码-步骤三 -->
					<div class="form step-3" v-show="forgetStep == 3">
						<div class="form-header">
							<div class="back" @click="back">
								<svg-icon name="arrowleft"></svg-icon>
							</div>
							<div class="heading">重置密码</div>
						</div>
						<div class="tip">请为{{ forgetForm.mobile }}账号设置新密码</div>
						<el-form-item prop="password">
							<div class="password-box">
								<el-input autocomplete="new-password" show-password clearable v-model="forgetForm.password" placeholder="8-16位且必须包含数字、大小写字母、符号中的任意两项"></el-input>
							</div>
						</el-form-item>
						<el-form-item prop="newPass">
							<div class="password-box">
								<el-input autocomplete="new-password" show-password clearable v-model="forgetForm.newPass" placeholder="再次输入密码"></el-input>
							</div>
						</el-form-item>
						<el-button class="reset-btn" type="primary" @click="checkPawd">重置</el-button>
					</div>
					<!-- 重置成功 -->
					<div class="form step-4" v-show="forgetStep == 4">
						<div class="form-header">
							<div class="heading">重置密码</div>
						</div>
						<div class="tit" style="text-align: center">密码重置成功，请前往登录</div>
						<div class="time">
							{{ threeNum }}秒
							<span :style="{ color: 'var(--color-text-4)', fontWeight: 500 }">后页面自动跳转</span>
						</div>
						<el-button class="reset-btn" type="primary" @click="toApply">去登录</el-button>
					</div>
				</el-form>
			</div>
		</div>
		<div class="footer">
			<div class="field">版权所有 {{ webInfo.copyright }}</div>
			<div class="field">联系方式：{{ webInfo.email }}</div>
		</div>

		<!-- 倒计时 -->
		<CountDown ref="CountDown" :value.sync="codeNum" :seconds="60" style="width: 0; height: 0; overflow: hidden"></CountDown>
		
		<!-- 拼图验证 -->
		<Vcode :show="isShow" @success="onSuccess" @close="onClose" />
	</div>
</template>

<script>
import { NSlider, SmsSend, ConfigValue, ValidateSms, ModifyPassword, ValidatePerson } from '@/common/api.js';
import SliderCode from '@/components/SliderCode/SliderCode.vue';
import CountDown from '@/components/CountDown/CountDown.vue';
import useJsencrypt from '@/common/useJsencrypt.js';
import { webInfo } from '@/common/data.js';
// 拼图验证
import Vcode from 'vue-puzzle-vcode';
export default {
	components: { SliderCode, CountDown, Vcode },
	data() {
		// 手机号验证
		var validatePhone = (rule, value, callback) => {
			let result = this.verifyVal({ val: value, rules: ['phone'] });
			if (result.valid) {
				callback();
			} else {
				callback(new Error('手机号格式不正确'));
			}
		};
		// 滑块验证
		var validateSlider = (rule, value, callback) => {
			if (value === false) {
				callback(new Error('请将滑块拖动至最右'));
			} else {
				callback();
			}
		};
		// 新密码验证
		var validatePassword = (rule, value, callback) => {
			var testPassword = /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%\^&*?.]{8,16}$/;
			if (!testPassword.test(value)) {
				callback(new Error('密码为8-16位且必须包含数字、大小写字母、符号中的任意两项'));
			} else {
				callback();
			}
		};
		// 确认新密码验证
		var validateNewPass = (rule, value, callback) => {
			if (value != this.forgetForm.password) {
				callback(new Error('两次输入不一致，请核实'));
			} else {
				callback();
			}
		};
		return {
			webInfo: webInfo,
			// 忘记密码的当前步骤 1 2 3
			forgetStep: 1,
			// 背景视频
			backgroundVideo: '',
			// 背景图片
			backgroundImage: '',
			isAgree: false,
			// 注册表单
			forgetForm: {
				// 手机号
				mobile: '',
				// 验证码
				verificationCode: '',
				// 滑块验证
				confirmSuccess: false,
				// 滑块验证hash
				sendHash: '',
				// 新密码
				password: '',
				// 确认新密码
				newPass: ''
			},
			forgetRule: {
				mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { validator: validatePhone }],
				verificationCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
				confirmSuccess: [{ validator: validateSlider }],
				password: [{ required: true, message: '请输入密码', trigger: 'blur' }, { validator: validatePassword }],
				newPass: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
					{ validator: validateNewPass, trigger: 'none' }
				]
			},
			codeNum: 60,
			value: '',
			inputList: [{ pinless: undefined }, { pinless: undefined }, { pinless: undefined }, { pinless: undefined }, { pinless: undefined }, { pinless: undefined }],
			// 3秒后页面自动跳转
			threeNum: 3,
			// 是否显示拼图验证
			isShow: false,
			smsSending: false,
			sliderKey: 0
		};
	},
	watch: {
		inputList: {
			handler: function (newValue) {
				let result = newValue.every((item) => {
					return Object.values(item).every((val) => val != undefined);
				});
				if (result) {
					this.checkVcode(newValue);
					return;
				}
				for (let inx = 0; inx < newValue.length; inx++) {
					if (!newValue[inx].pinless) {
						if (inx === 5) {
							for (let index = 0; index < newValue.length; index++) {
								// 用户从中间开始输入情况处理
								if (newValue[index].pinless === undefined) {
									// this.inputList[index].focus();
									this.$refs[`inputList-${index}`][0].focus();
									return;
								}
							}
						} else {
							this.$refs[`inputList-${inx}`][0].focus();
							return;
						}
					}
				}
			},
			deep: true
		}
	},
	created() {
		this.getConfigValue();
	},
	methods: {
		// 检查是否可以拖动滑块
		checkCanSliderCode() {
			this.$refs.forgetForm.validateField('mobile', (errorMessage) => {
				if (errorMessage) {
					this.$refs.SliderCode.sliderCodeable = false
				} else {
					this.$refs.SliderCode.sliderCodeable = true
				}
			});
		},
		// 核对密码
		checkPawd() {
			//
			this.$refs.forgetForm.validate((valid) => {
				if (valid) {
					this.modifyPawd();
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 修改密码
		modifyPawd() {
			let data = {
				mobile: this.forgetForm.mobile,
				systemType: 'CARBON_DATA',
				verificationCode: this.forgetForm.verificationCode,
				password: this.forgetForm.password
			};
			ModifyPassword(data).then((res) => {
				if (res.success) {
					this.threeNum = 3;
					let timer = setInterval(() => {
						this.threeNum--;
						if (this.threeNum == 0) {
							clearInterval(timer);
							this.$router.push({ name: 'login' });
						}
					}, 1000);
					this.forgetStep = 4;
				} else {
					this.$message.error(res.message);
				}
			});
		},
		// 核对验证码
		checkVcode(list) {
			let code = list.map((item) => item.pinless).join('');
			let obj = {
				mobile: this.forgetForm.mobile,
				verificationCode: code
			};
			ValidateSms(obj).then((res) => {
				if (res.success) {
					this.forgetStep = 3;
					this.forgetForm.verificationCode = code;
				} else {
					this.$message.error(res.message);
				}
			});
		},
		// 返回
		back() {
			if (this.forgetStep == 3) {
				this.forgetStep = 2;
			} else if (this.forgetStep == 2) {
				this.forgetStep = 1;
			} else if (this.forgetStep == 1) {
				this.$router.push({ name: 'login' });
			}
		},
		// 获取背景视频、图片
		getConfigValue() {
			ConfigValue({
				configKey: 'login.background.video'
			}).then((res) => {
				this.backgroundVideo = res.data;
			});
			ConfigValue({
				configKey: 'login.background.image'
			}).then((res) => {
				this.backgroundImage = res.data;
			});
		},
		resetSlider() {
			this.forgetForm.confirmSuccess = false;
			this.forgetForm.sendHash = '';
			this.sliderKey += 1;
		},
		// 发送验证码（滑块票据后端仅 60s，拖完后应尽快发送）
		sendCode() {
			if (this.smsSending) {
				return;
			}
			this.$refs.forgetForm.validateField('mobile', (errorMessage) => {
				if (!errorMessage) {
					this.$refs.forgetForm.validateField('confirmSuccess', (confirmSuccess_errorMessage) => {
						if (!confirmSuccess_errorMessage) {
							if (this.$refs.CountDown.canGetCode) {
								if (!this.forgetForm.sendHash) {
									this.$message.warning('请先完成滑块验证');
									this.resetSlider();
									return;
								}
								let data = {
									smsType: 'forgetPassword',
									code: useJsencrypt(this.forgetForm.sendHash)
								};
								this.smsSending = true;
								SmsSend(data)
									.then((res) => {
										if (res.success) {
											if (res.code === '163') {
												this.onShow();
											} else {
												this.forgetStep = 2;
												this.$refs.CountDown.start();
												this.resetSlider();
											}
										} else {
											this.$message.error(res.message || '发送失败');
											if ((res.message || '').indexOf('已失效') !== -1) {
												this.$message.warning('滑块已过期，请重新拖动后再获取验证码');
											}
											this.resetSlider();
										}
									})
									.finally(() => {
										this.smsSending = false;
									});
							}
						}
					});
				}
			});
		},
		// 打开拼图验证
		onShow() {
			this.isShow = true;
		},
		// 关闭拼图验证
		onClose() {
			this.isShow = false;
		},
		// 拼图验证成功
		onSuccess() {
			let data = {
				mobile: this.forgetForm.mobile
			};
			ValidatePerson(data).then((res) => {
				if (res.success) {
					this.onClose();
					this.sendCode();
				}
			});
		},
		// 去注册申请
		toApply() {
			this.$refs.forgetForm.validate((valid) => {
				if (valid) {
					let obj = {
						mobile: this.forgetForm.mobile,
						verificationCode: this.forgetForm.verificationCode
					};
					this.$store.commit('changeRegInfo', obj);
					this.$router.push({ name: 'forgetApply' });
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 滑块操作成功：拿到票据后立即发短信，避免超过后端 60s 有效期
		confirmSuccessFn(val) {
			this.forgetForm.confirmSuccess = val;
			if (!val) {
				return;
			}
			let data = {
				mobile: this.forgetForm.mobile
			};
			NSlider(data).then((res) => {
				if (res.success || res.code === '200') {
					this.forgetForm.sendHash = res.data;
					this.sendCode();
				} else {
					this.$message.error(res.message || '滑块验证失败');
					this.resetSlider();
				}
			}).catch(() => {
				this.resetSlider();
			});
		}
	}
};
</script>

<style lang="scss" scoped>
@function vw($px) {
	@return $px / 1440 * 100vw;
}

@function vh($px) {
	@return $px / 735 * 100vh;
}
.login-page {
	// flex: 1;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	// background-image: url('~@/assets/tmp/017.png');
	background-size: cover;
	position: relative;
	video {
		z-index: -1;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 100%;
		// width: 100vw;
		// height: 100vh;
		object-fit: cover;
	}
	.bg {
		z-index: -1;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 100%;
		// width: 100vw;
		// height: 100vh;
		object-fit: cover;
	}
	.svg-logo {
		position: absolute;
		top: 0;
		left: 0;
		margin-top: vh(10);
		margin-left: vw(40);
		width: 328px;
		height: 41px;
	}
	.body {
		flex: 1;
		display: flex;
		justify-content: space-between;
		.body-left {
			margin-left: vw(94);
			flex: 1;
			padding-right: vw(20);
			align-self: center;
			transform: translateY(-160px);
		
			.heading-1 {
				// margin-top: vh(216);
				font-family: FZLTCHJW--GB1, FZLTCHJW--GB1;
				font-weight: bold;
				font-size: 40px;
				color: #FFFFFF;
				line-height: 51px;
				letter-spacing: 3px;
			}
		
			.heading-2 {
				margin-top: 10px;
				font-family: FZLTCHJW--GB1, FZLTCHJW--GB1;
				font-weight: bold;
				font-size: 40px;
				color: #FFFFFF;
				line-height: 51px;
				letter-spacing: 3px;
			}
		
			.des {
				width: 465px;
				margin-top: 73px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #FFFFFF;
				line-height: 21px;
			}
		}
		.body-right {
			margin-right: vw(90);
			align-self: center;

			// 忘记密码
			.forget-card {
				// 步骤一
				.form.step-1 {
					width: 390px;
					height: 460px;
					background: #ffffff;
					box-sizing: border-box;
					padding: 0 28px;
					display: flex;
					flex-direction: column;
					position: relative;
					.form-header {
						display: flex;
						justify-content: center;
						align-items: center;
						position: relative;
						.heading {
							margin-top: 25px;
							margin-bottom: 25px;
							font-weight: bold;
							font-size: 16px;
							color: #000000;
							line-height: 22px;
							text-align: center;
						}
						.back {
							position: absolute;
							left: 0;
							cursor: pointer;
							.svg-icon {
								width: 22px;
								height: 15px;
							}
						}
					}
					.phone-box {
						margin-top: 20px;
						position: relative;
						display: flex;
						align-items: center;
						::v-deep {
							.el-input {
								.el-input__inner {
									height: 46px;
									// padding-left: 73px;
									background: rgba(#ffffff, 1);
									border-radius: 0;
									font-size: 14px;
									&::placeholder {
										color: #9e9e9e;
									}
								}
							}
						}
						.prefix {
							left: 15px;
							position: absolute;
							font-size: 14px;
							color: #000000;
							line-height: 20px;
						}
					}
					.slide {
						margin-top: 20px;
						height: 34px;
						background: #ffffff;
						border: 1px solid #e9e9e9;
					}
					.tip {
						margin-top: 25px;
						color: #009944;
						font-size: 14px;
						text-align: center;
					}
					.send-btn {
						margin-top: auto;
						margin-bottom: 76px;
						display: flex;
						justify-content: center;
						align-items: center;
						padding: 0;
						border-radius: 0;
						height: 46px;
						line-height: 46px;
						font-weight: bold;
						font-size: 16px;
					}
					.card-footer {
						height: 56px;
						background: #f8f9fc;
						display: flex;
						position: absolute;
						bottom: 0;
						align-items: center;
						padding: 0 28px;
						justify-content: center;
						width: 100%;
						left: 0;
						box-sizing: border-box;
						.forget {
							font-size: 12px;
							color: #9e9e9e;
							display: flex;
							align-items: center;
							.tologin {
								display: flex;
								align-items: center;
							}
							img {
								width: 6px;
								height: 8px;
								margin-left: 5px;
							}
						}
					}
				}

				// 步骤二
				.form.step-2 {
					width: 390px;
					height: 460px;
					background: #ffffff;
					box-sizing: border-box;
					padding: 0 28px;
					display: flex;
					flex-direction: column;
					position: relative;
					.form-header {
						display: flex;
						justify-content: center;
						align-items: center;
						position: relative;
						.heading {
							margin-top: 25px;
							margin-bottom: 25px;
							font-weight: bold;
							font-size: 16px;
							color: #000000;
							line-height: 22px;
							text-align: center;
						}
						.back {
							position: absolute;
							left: 0;
							cursor: pointer;
							.svg-icon {
								width: 22px;
								height: 15px;
							}
						}
					}
					.tip {
						margin-top: 25px;
						color: #86909c;
						font-size: 14px;
						text-align: center;
					}
					.code-box {
						margin-top: 40px;
						margin-bottom: 40px;
						position: relative;
						display: flex;
						align-items: center;
						justify-content: space-between;
						::v-deep {
							.el-input {
								width: auto;
								.el-input__inner {
									width: 46px;
									height: 46px;
									// padding-left: 73px;
									background: rgba(#ffffff, 1);
									border-radius: 0;
									font-size: 14px;
									text-align: center;
									&::placeholder {
										color: #9e9e9e;
									}
								}
							}
						}
						.line {
							width: 15px;
							height: 1px;
							background-color: #000000;
						}
					}
					.reSend {
						text-align: center;
						color: rgb(var(--primary-6));
						font-size: 14px;
						cursor: pointer;
					}
				}

				// 步骤三
				.form.step-3 {
					width: 390px;
					height: 460px;
					background: #ffffff;
					box-sizing: border-box;
					padding: 0 28px;
					display: flex;
					flex-direction: column;
					position: relative;
					.form-header {
						display: flex;
						justify-content: center;
						align-items: center;
						position: relative;
						.heading {
							margin-top: 25px;
							margin-bottom: 25px;
							font-weight: bold;
							font-size: 16px;
							color: #000000;
							line-height: 22px;
							text-align: center;
						}
						.back {
							position: absolute;
							left: 0;
							cursor: pointer;
							.svg-icon {
								width: 22px;
								height: 15px;
							}
						}
					}
					.tip {
						margin-top: 25px;
						color: #86909c;
						font-size: 14px;
						text-align: left;
					}

					.password-box {
						margin-top: 20px;
						position: relative;
						display: flex;
						align-items: center;
						::v-deep {
							.el-input {
								.el-input__inner {
									height: 46px;
									// padding-left: 73px;
									background: rgba(#ffffff, 1);
									border-radius: 0;
									font-size: 14px;
									&::placeholder {
										color: #9e9e9e;
									}
								}
							}
						}
						.prefix {
							left: 15px;
							position: absolute;
							font-size: 14px;
							color: #000000;
							line-height: 20px;
						}
					}
					.reset-btn {
						margin-top: auto;
						margin-bottom: 40px;
						display: flex;
						justify-content: center;
						align-items: center;
						padding: 0;
						border-radius: 0;
						height: 46px;
						line-height: 46px;
						font-weight: bold;
						font-size: 16px;
					}
				}

				// 步骤四
				.form.step-4 {
					width: 390px;
					height: 460px;
					background: #ffffff;
					box-sizing: border-box;
					padding: 0 28px;
					display: flex;
					flex-direction: column;
					position: relative;
					.form-header {
						display: flex;
						justify-content: center;
						align-items: center;
						position: relative;
						.heading {
							margin-top: 25px;
							margin-bottom: 25px;
							font-weight: bold;
							font-size: 16px;
							color: #000000;
							line-height: 22px;
							text-align: center;
						}
						.back {
							position: absolute;
							left: 0;
							cursor: pointer;
							.svg-icon {
								width: 22px;
								height: 15px;
							}
						}
					}
					.tip {
						margin-top: 25px;
						color: #86909c;
						font-size: 14px;
						text-align: left;
					}

					.tit {
						color: var(--color-text-1);
						font-size: 20px;
						font-weight: 600;
						margin-top: 80px;
					}

					.time {
						color: rgb(var(--primary-6));
						font-size: 16px;
						text-align: center;
						margin-top: 40px;
						font-weight: 600;
					}

					.reset-btn {
						margin-top: auto;
						margin-bottom: 40px;
						display: flex;
						justify-content: center;
						align-items: center;
						padding: 0;
						border-radius: 0;
						height: 46px;
						line-height: 46px;
						font-weight: bold;
						font-size: 16px;
					}
				}
			}
		}
	}
	.footer {
		display: flex;
		justify-content: center;
		position: absolute;
		left: 0;
		right: 0;
		bottom: vh(27);
		.field {
			font-size: 12px;
			color: #ffffff;
			line-height: 27px;
			text-align: center;
			margin: 0 5px;
		}
	}
}
</style>
